module.exports = __webpack_public_path__ + "img/ViDienTu.51d4ebcb.svg";